import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children, allowedRoles }) => {

    // Este componente se utiliza para redirijir al usuario a una pagina "/unauthorized" en caso no tenga los permisos para ver dicha página

    const user = useSelector((state) => state.auth.user);
    const role = user.role

    const tokenExp = localStorage.getItem("tokenExp");

    // Función para verificar si el token ha expirado
    const isTokenExpired = () => {
        if (!tokenExp) return true;
        const currentTime = Math.floor(Date.now() / 1000);
        return parseInt(tokenExp) < currentTime;
    };

    if (!user || isTokenExpired()) {
        return <Navigate to="/" />; // Redirige al login si no está autenticado o si el token ha expirado
    }

    if (allowedRoles && !allowedRoles.includes(role)) {
        return <Navigate to="/unauthorized" />; // Redirige si no tiene los roles permitidos
    }

    return children; // Renderiza el componente si todo está bien
};

export default PrivateRoute;
